
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 35 35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.26534 25.6365L8.78984 19.3635H9.66284L12.1783 25.6365H10.9093L10.4548 24.408H7.99334L7.53884 25.6365H6.26534ZM8.38034 23.3685H10.0723L9.23084 21.0825L8.38034 23.3685Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M6.44534 15.6365V14.6825L9.80234 10.403H6.65234V9.3635H11.2648V10.322L7.89884 14.597H11.3818V15.6365H6.44534Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M22.5001 21.6716L27.864 16.3076L29.2782 17.7218L21.5001 25.5L13.7218 17.7218L15.136 16.3076L20.5001 21.6716V9.5H22.5001V21.6716Z","fill":"currentColor"}})])
          )
        }
      }
    